<template>
  <div class="VIPInstruction">
    <c-nav></c-nav>
    <div class="title t-a-c">高铁管家会员服务条款</div>
    <div class="a-text-14 a-gray">本协议是您与高铁管家(所有者深圳市活力天汇科技股份有限公司)之间就高铁管家会员服务使用事宜所订立的契约。请您仔细阅读本协议，关于本协议，提示您特别关注限制、免责条款，违约责任条款，争议解决和法律适用条款等。如果您不同意本协议的任意内容，或者无法准确理解高铁管家对条款的解释，请不要同意本协议或使用本协议下的服务。否则，您点击“同意”按钮后，本协议即构成双方有约束力的法律文件。</div>
    <div class="content">
      <div class="subTitle">一、高铁管家会员介绍</div>
      <div>
        <p>1、高铁管家会员:高铁管家会员是为高铁管家客户打造的会员服务，通过提供高品质的客户服务，让旅途安心。高铁会员服务目前包含常旅客礼包、选下铺礼包、机票礼包、休息室礼包、打车礼包、无限次抢票礼包等6种礼包权益，以及最佳助攻手、机票买贵赔、酒店会员价、专属客服等4项专属权益</p>
        <p>2、高铁管家会员活动仅针对消费记录良好且在高铁管家购票的个人用户开放参与资格，可付费购买一年期高铁管家会员资格，会员有效期为自开通之日起至365天后为止，仅限有效期内可使用；</p>
        <p>3、用户购买会员后，如需开具发票，联系高铁管家客服申请；</p>
        <p>4、通过品牌合作渠道兑换黄金会员资格的用户，所享有的权益以对应品牌渠道的公示为准。</p>
      </div>
      <div class="subTitle">二、服务条款的确认和接纳</div>
      <div>
        <p>1、本次提供的高铁管家会员服务所有权和运作权归高铁管家所有；</p>
        <p>2、用户点击同意本协议的，即视为用户确认同意接受高铁管家会员相关服务条款，且同意按本协议内容履行，如产生用户相关责任的，同意承担相应法律责任；</p>
        <p>3、如果您在18周岁以下，您只能在父母或监护人的监护参与下购买并体验该服务；</p>
        <p>4、高铁管家保留在中华人民共和国大陆地区施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容等相关权利；</p>
        <p>5、高铁管家会员开通后，您在已开通的服务期内中途主动取消或终止资格或者未使用完服务的，将不获得为开通本服务而已支付费用的退还；</p>
        <p>6、高铁管家会员仅限在高铁管家客户端使用；</p>
        <p>7、高铁管家有权限根据实际需要将本协议项下的部分或者全部服务委托其关联公司执行。</p>
      </div>
      <div class="subTitle">三、会员等级划分和具体权益</div>
      <div>
        <p>1、高铁管家会员分3个等级，分别是：黄金会员，白金会员和钻石会员；</p>
        <p>2、高铁管家会员的获得有多种形式：<br />（1）通过购买礼包成为高铁管家会员，其中黄金会员49元/年，白金会员99元/年，钻石会员199元/年；<br />（2）通过高铁管家活动获得会员体验，比如签到，邀请好友，直接领取等(具体活动形式和时间不定，请多留意)</p>
        <p>3、用户可通过购买以下6种礼包中的任意一种，成为会员：<br />（1）【常旅客礼包】——黄金会员常旅客礼包包含首单返现15元，单单返现5元，全年最多返现8次，每月最多返现5次，总价值55元；白金会员常旅客礼包包含首单返现20元，单单返现8元，全年最多返现12次，每月最多返现5次，总价值116元；钻石会员常旅客礼包包含首单返现50元，单单返现10元，全年最多返现19次，每月最多返现5次，总价值240元。返现金额均可提现到支付宝。<br />（2）【选下铺礼包】——黄金会员选下铺礼包包含4单指定出下铺票，4单夜间购票不用等，总价值700元；白金会员选下铺礼包包含8单指定出下铺票，8单夜间购票不用等，总价值1400元；钻石会员选下铺礼包包含16单指定出下铺票，16单夜间购票不用等，总价值2800元。<br />（3）【机票礼包】——黄金会员机票礼包包含首单返现20元，单单返现5元，全年最多返现24次，每月限2次，总价值140元；白金会员机票礼包包含首单返现50元，单单返现8元，全年最多返现24次，每月限2次，总价值242元；钻石会员机票礼包包含首单返现100元，单单返现15元，全年最多返现24次，每月限2次，总价值460元。返现金额均可提现到支付宝。<br />（4）【休息室礼包】——黄金会员休息室礼包包含1单免费休息室，20元休息室红包，总价值60元；白金会员休息室礼包包含2单免费休息室，40元休息室红包，总价值120元；钻石会员休息室礼包包含4单免费休息室，80元休息室红包，总价值240元。<br />（5）【打车礼包】——黄金会员打车礼包包含1张打车免单券，最高抵扣20元，6张打车直减券，内含45元打车直减券包，总价值65元；白金会员打车礼包包含3张打车免单券，最高抵扣20元，15张打车直减券，内含105元打车直减券包，总价值165元；钻石会员打车礼包包含5张打车免单券，最高抵扣20元，25张打车直减券，内含175元打车直减券包，总价值275元。<br />（6）【无限次抢票礼包】——黄金会员无限次抢票礼包，可为3位受益人无限次使用VIP抢票券和无限次使用优先出票权，总价值400元；白金会员无限次抢票礼包，可为5位受益人无限次使用VIP抢票券和无限次使用优先出票权，总价值800元；钻石会员无限次抢票礼包，可为9位受益人无限次使用VIP抢票券和无限次使用优先出票权，总价值1600元。</p>
        <p>4、除礼包权益外，高铁管家不同会员等级享受不同的专属权益，其中：<br />（1）【黄金会员】——可享受部分酒店预订最高9.4折会员价，机票价格与携程平台同一航班、仓位对比买贵时赔1.5倍差价，每年自动发放最佳助攻手3次，可助好友抢票加速至光速等级；<br />（2）【白金会员】——可享受部分酒店预订最高9.2折会员价，机票价格与携程平台同一航班、仓位对比买贵时赔2倍差价，每年自动发放最佳助攻手5次，可助好友抢票加速至光速等级；<br />（3）【钻石会员】——可享受部分酒店预订最高9.0折会员价，机票价格与携程平台同一航班、仓位对比买贵时赔3倍差价，每年自动发放最佳助攻手8次，可助好友抢票加速至光速等级，配有一对一的专属客服服务。</p>
      </div>
      <div class="subTitle">四、使用注意事项</div>
      <div>
        <p>1、提交开通申请时，绑定账号为用户当前登录账号，用户应保证其资料真实、准确、完整、合法有效。一经开通无法进行修改。如果用户提供的注册资料不合法、不真实、不准确、不详尽，用户需承担因此引起的相应责任及后果，并且高铁管家保留终止用户参与该活动的权利；</p>
        <p>2、服务开通后，用户应谨慎合理的保存、使用其用户名和密码，不得将在本站注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，同时高铁管家在该种情况下有权做出独立判断，可采取暂停或关闭用户参与资格等措施；</p>
        <p>3、用户同意，高铁管家拥有通过邮件、短信、电话等形式，向其发送相关活动等必要信息的权利；</p>
        <p>4、用户同意，其应合理使用其享有的会员权益，除为实现用户自身的会员权益外，不得利用其享有的权益非法获利，不得以任何形式售卖其所享有的权益，不得滥用其所享有的权益，如因用户不当行为致高铁管家合理怀疑的或判定的，高铁管家有权暂停或关闭用户该活动的权益，此外，用户需承担因此引起的相应责任及后果。</p>
      </div>
      <div class="subTitle">五、协议更新及用户关注义务</div>
      <div>
        <p>根据国家法律及高铁管家平台运营需要，高铁管家有权以公告或推送的形式不定期地制定、修改本协议或相关服务规则，暂停、取消和修改本协议条款，修改后的协议一旦被公告即生效，并代替原来的协议。用户应及时关注不时发布的各项服务规则和本协议的变更。若不同意相关规则及条款修改的，应及时终止与平台的协议。如用户继续使用平台提供的服务的，即视为同意更新后的协议。高铁管家建议您在使用前阅读本协议及通知公告。</p>
      </div>
      <div class="subTitle">六、法律管辖和适用</div>
      <div>
        <p>本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律(但不包括其中冲突规则)。如发生本协议与适用之法律相抵触时，则这些条款将完全按照法律规定重新解释，而其他有效条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好地协商解决；协商不成时，任何一方可向高铁管家所在地深圳市南山区人民法院提起诉讼。</p>
      </div>
      <div class="subTitle">七、其他</div>
      <div>
        <p>1、高铁管家平台所有者是指政府部门依法许可或备案的高铁管家经营主体；</p>
        <p>2、如因不可抗力或其他高铁管家无法控制的原因致使会员服务无法及时或无法按本协议进行的，高铁管家会合理地尽力协助处理善后事宜；</p>
        <p>3、用户除遵守本《高铁管家会员服务协议》外，仍应同时遵守《高铁管家服务条款》等其他您与高铁管家签署确认的协议。</p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    mounted () { 
      this.$updateTitle('高铁管家会员服务条款');
    }
  }
</script>
<style lang="scss" scoped>
  @import '@/scss/_vars.scss';
  @import './style/common.scss';
  .VIPInstruction {
    user-select: none;
    padding: 0 14*$px;
    padding-bottom: 10*$px;
    color: #333;
    .title {
      margin-top: 15*$px;
      font-size: 22*$px;
    }
    .content {
      .subTitle {
        margin-top: 10*$px;
        margin-bottom: 8*$px;
        font-size: 18*$px;
      }
      p {
        font-size: 16*$px;
        line-height: 24*$px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/projects/vipCard/pages/huaweiVIP/VIPInstruction.vue